export default __webpack_public_path__ + "static/thumb-video2-db9d9c2d296955fc56ae2fa09d0b3bb1.png";